export type ReportReason =
  | 'SPAM'
  | 'HARASSMENT'
  | 'HATE_SPEECH'
  | 'VIOLENCE'
  | 'SEXUAL_CONTENT'
  | 'MISINFORMATION'
  | 'COPYRIGHT'
  | 'OTHER';

export type ReportStatus = 'PENDING' | 'REVIEWING' | 'RESOLVED' | 'DISMISSED';

export type ReportEntityType = 'POST' | 'COMMENT' | 'REVIEW';

export interface ContentReportAuthor {
  id: number;
  firstName?: string;
  lastName?: string;
  username?: string;
  photoUrl?: string;
}

export interface ReportedContent {
  id: number;
  content?: string;
  authorId: number;
  author?: ContentReportAuthor;
  createdAt?: string;
  // For posts
  images?: Array<{ id: number; url: string }>;
  likesCount?: number;
  commentsCount?: number;
  viewsCount?: number;
  // For comments
  postId?: number;
}

export interface ContentReport {
  id: number;
  reporterId: number;
  entityType: ReportEntityType;
  entityId: number;
  reason: ReportReason;
  description?: string;
  status: ReportStatus;
  resolutionReason?: string;
  reviewedBy?: number;
  resolvedAt?: string;
  createdAt: string;
  updatedAt: string;
  reporter?: ContentReportAuthor;
  reviewer?: {
    id: number;
    username: string;
    email?: string;
  };
  // Enriched content data
  reportedContent?: ReportedContent;
}

export interface ReportStats {
  pending: number;
  reviewing: number;
  resolved: number;
  dismissed: number;
}

export const REPORT_REASON_LABELS: Record<ReportReason, string> = {
  SPAM: 'Спам',
  HARASSMENT: 'Оскорбления',
  HATE_SPEECH: 'Язык ненависти',
  VIOLENCE: 'Насилие',
  SEXUAL_CONTENT: 'Сексуальный контент',
  MISINFORMATION: 'Дезинформация',
  COPYRIGHT: 'Нарушение авторских прав',
  OTHER: 'Другое',
};

export const REPORT_STATUS_LABELS: Record<ReportStatus, string> = {
  PENDING: 'На рассмотрении',
  REVIEWING: 'В процессе',
  RESOLVED: 'Решено',
  DISMISSED: 'Отклонено',
};

export const REPORT_ENTITY_TYPE_LABELS: Record<ReportEntityType, string> = {
  POST: 'Пост',
  COMMENT: 'Комментарий',
  REVIEW: 'Отзыв',
};
